import { FC, useState } from "react";
import {
  Box,
  Checkbox,
  Chip,
  ListItemText,
  OutlinedInput,
  Select,
  Button,
  Typography,
  useTheme,
  Dialog,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { Stack } from "@mui/system";

interface MultiSelectFieldProps {
  question: {
    field_key: string;
    required: boolean;
    options?: string[];
  };
  selectedValues: string[];
  onChange: (value: string[]) => void;
}

const MultiSelectField: FC<MultiSelectFieldProps> = ({ question, selectedValues, onChange }) => {
  const { palette } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  function _handleChange(option: string): void {
    const newValues = selectedValues.includes(option)
      ? selectedValues.filter((v) => v !== option)
      : [...selectedValues, option];
    onChange(newValues);
  }

  return (
    <>
      <div onClick={() => setIsOpen(true)}>
        <Select
          multiple
          fullWidth
          required={question.required}
          name={question.field_key}
          value={selectedValues}
          readOnly
          input={<OutlinedInput />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {(selected as string[]).map((value) => (
                <Chip
                  key={value}
                  label={value}
                  sx={{
                    maxWidth: "100%",
                    height: "auto",
                    "& .MuiChip-label": {
                      whiteSpace: "normal",
                      display: "block",
                      overflow: "visible",
                    },
                  }}
                />
              ))}
            </Box>
          )}
        />
      </div>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth maxWidth="xs">
        <Box
          sx={{
            backgroundColor: palette.background.default || "white",
            p: 2,
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body1">Selecione 1 ou mais opções</Typography>
            <Button
              startIcon={<Close />}
              color="primary"
              variant="text"
              onClick={() => setIsOpen(false)}
            >
              Fechar
            </Button>
          </Stack>
        </Box>
        <DialogContent sx={{ p: 0 }}>
          <List>
            {(question.options ?? []).map((option) => (
              <ListItem key={option} disablePadding>
                <ListItemButton onClick={() => _handleChange(option)}>
                  <ListItemIcon>
                    <Checkbox
                      checked={selectedValues.includes(option)}
                      edge="start"
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={option}
                    primaryTypographyProps={{
                      style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)} color="primary" variant="contained" fullWidth>
            Concluir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MultiSelectField;
